import React from "react";
import Creatable from "react-select/creatable";

import Tag from "./Tag";
import { options } from "../utilities";

export default ({
  label,
  optionList,
  placeholder,
  unselectTag,
  name,
  addFromSelect,
  tags,
}) => (
  <div className="my-select">
    <label>
      {label && <div className="auth-label">{label}</div>}
      <Creatable
        options={options(optionList || [])}
        isSearchable
        isMulti
        isClearable={false}
        onChange={(values) => addFromSelect(values, name)}
        className="auth-select"
        classNamePrefix="select"
        placeholder={placeholder}
        value={null}
      />
    </label>
    <div className="tags-container">
      {" "}
      {tags.map((tag, index) => (
        <Tag
          selected
          label={tag}
          key={`${name}-tags-${index}`}
          unselect={() => unselectTag(tag, name)}
          creating={!optionList.includes(tag)}
        />
      ))}
    </div>
  </div>
);
